import { useEffect, useState } from "react";
import { Flex, Text, Button, useToast, Spinner } from "@chakra-ui/react";
import { Link, useLocation } from "react-router-dom";
const BACKEND_URL = process.env.REACT_APP_API_BASE_URL;


const SuccessPage = ({ fetchUser }) => {
  const toast = useToast();
  const location = useLocation();
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    const checkSessionAndUpdate = async () => {
      const params = new URLSearchParams(location.search);
      const sessionId = params.get('session_id');

      try {
        setChecking(true);
        if (sessionId) {
          const token = localStorage.getItem('token');
          const res = await fetch(`${BACKEND_URL}/billing/session/${sessionId}`, {
            headers: { Authorization: `Bearer ${token}` },
          });

          if (res.ok) {
            const session = await res.json();
            const paid = session.payment_status === 'paid' || session.status === 'complete' || session.status === 'paid';
            if (paid) {
              await fetchUser();
              toast({
                title: 'Crediti aggiornati!',
                description: 'Il tuo abbonamento/ricarica è stato attivato correttamente.',
                status: 'success',
                duration: 5000,
                isClosable: true,
              });
            } else {
              // Pagamento non definitivo: richiedi comunque lo stato utente (webhook potrebbe aver aggiornato)
              await fetchUser();
              toast({
                title: 'Pagamento in elaborazione',
                description: 'Il pagamento è in fase di elaborazione. Se i crediti non sono immediatamente aggiornati verranno aggiornati dal webhook.',
                status: 'info',
                duration: 7000,
                isClosable: true,
              });
            }
          } else {
            // Non siamo riusciti a recuperare la sessione: fallback a refresh utente
            await fetchUser();
            toast({
              title: 'Verifica non disponibile',
              description: 'Non è stato possibile verificare lo stato della sessione, ma i crediti verranno aggiornati dal webhook.',
              status: 'warning',
              duration: 7000,
              isClosable: true,
            });
          }
        } else {
          // Nessun session_id: fallback semplice
          await fetchUser();
          toast({
            title: 'Crediti aggiornati!',
            description: 'Il tuo abbonamento/ricarica è stato attivato correttamente.',
            status: 'success',
            duration: 5000,
            isClosable: true,
          });
        }
      } catch (err) {
        console.error('Errore aggiornamento crediti:', err);
        toast({
          title: 'Errore',
          description: "Non è stato possibile aggiornare i crediti.",
          status: 'error',
          duration: 5000,
          isClosable: true,
        });
      } finally {
        setChecking(false);
      }
    };

    checkSessionAndUpdate();
  }, [fetchUser, location.search, toast]);

  return (
    <Flex direction="column" align="center" justify="center" minH="100vh" bg="green.50" p={6}>
      {checking ? (
        <Flex direction="row" align="center" mb={4}>
          <Spinner size="lg" color="green.600" mr={4} />
          <Text fontSize="lg" color="green.700">Verifica pagamento in corso...</Text>
        </Flex>
      ) : (
        <Text fontSize="3xl" color="green.700" mb={4}>
          ✅ Pagamento completato con successo!
        </Text>
      )}
      <Text fontSize="lg" color="gray.700" mb={6}>
        I tuoi crediti sono stati aggiornati. Puoi tornare alla dashboard per usarli subito.
      </Text>
      <Button as={Link} to="/" colorScheme="green" size="lg">
        Torna alla Dashboard
      </Button>
    </Flex>
  );
};

export default SuccessPage;
